import React from 'react';
import './customerOrders.scss';

import { useAuth } from  '../../contexts/auth'; 
import orderDue from './orderInvoicingDetail.js';

import { createStore } from 'devextreme-aspnet-data';
import { useState, useEffect, useCallback } from "react";

import notify from 'devextreme/ui/notify';
import { confirm } from 'devextreme/ui/dialog';

import {Button as ToolbarButton} from 'devextreme-react/button';

import DataGrid, {
    Column,
   // Export,
    MasterDetail,
    Format,
    //Popup,
    Form,
    Item,
    Button,
    Pager,
    Paging,
   // FilterRow,
    HeaderFilter,
    Lookup,
    Editing,
    Selection,
    Summary,
    Toolbar,
    //GroupItem,
    TotalItem,
    SearchPanel
  } from 'devextreme-react/data-grid';
  
  const serviceUrl5 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/OrdineClienteRata'
  const debug = process.env.ENTITY_DEBUG;

  export const numeriRata =  [{id:1,desc: '1'},{id:2,desc: '2'},{id:3,desc: '3'},{id:4,desc: '4'},{id:5,desc: '5'},{id:6,desc: '6'}];


export default function OrderInvoicing(props) {

    var orderInvocingDataGridRef = React.createRef();

    const [condizioniPagam, setCondizioniPagam] = useState({});

    const [currentRataRow, setCurrentRataRow] = useState(0);
    const [isRowRataSelected, setIsRowRataSelected] = useState(false);

    const { user } = useAuth(); 

    const [statiRate, setStatiRate] = useState({});

    
    // const filterPayload = { 
    //     idSuper: props.myKey,
    //     noNotes: true
    // };
  
    const isEditable = props.status === 5 ? true : false;
    const isUpdateble = props.status !== 3 ? true : false;
    console.log("Modificabile: " + isEditable);

    const remoteDataSource5 = createStore({

        key: 'id',
        loadUrl: serviceUrl5 + '/FindByOrdineCliente/' + props.myKey,
        onBeforeSend: (method, ajaxOptions) => {
            ajaxOptions.headers = { Authorization: `Bearer ${user.token}` } 
        },  
        //loadUrl: serviceUrl5 + '/FindByOrdineCliente/' + myKey,
        insertUrl: serviceUrl5 + '/InsertAction',
        updateUrl:serviceUrl5 + '/UpdateAction',
        deleteUrl: serviceUrl5 + '/DeleteAction'
        
    });

    useEffect(() => {

        const fetchData = async () => {
    
        const newServiceUrl6 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/CondizioniPagamento';
        var newUrl6 =  newServiceUrl6 + "/GetAction";
    
        const newServiceUrl12 = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/RataStato';
        var newUrl12 =  newServiceUrl12 + "/GetAction";
    
            try {
                
                const response6 = await fetch(newUrl6);
                const json6 = await response6.json();
                if (debug === 1)
                    console.log(json6);
                setCondizioniPagam(json6);
        
                const response12 = await fetch(newUrl12);
                const json12 = await response12.json();
                if (debug === 1)
                    console.log(json12);
                setStatiRate(json12);
        
            } catch (error) {
                console.log("error", error);
            }
        };
    
        fetchData();
    }, []);


    const showInvoiceIcon = useCallback((e) => {
        return e.row.data.fatturaId !== null;
    }, []);

    function createInvoice() {
    
        let result = confirm("<i>Procedere con la creazione di una fattura a partire dalla rata selezionata?</i>", "Crea Fattura");
        result.then((dialogResult) => {
            if  (dialogResult) {
                creaFattura(currentRataRow);
            } 
          //alert(e.row.data.id); 
        });
    }
    
    
    const creaFattura= (idRata) => {

        const url = process.env.REACT_APP_WEBAPP_DOMAIN + '/api/FatturaCliente/CreateFatturaClienteFromRata/' + idRata;
      
        const requestOptions = {
          method: 'PUT',
          //body: JSON.stringify(detailAllievo),
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${user.token}`
          }
        };
      
        return fetch(url, requestOptions)
            .then(response => {
            if(response.ok) return response.json();
                //Global.CheckResponseAuth(response);
                return null;
            })
            .then(data => { 
                ;
                setTimeout(() => { 
                notify(data.message, data.success ? 'success' : 'error', 2000);         
                }, 100);
            })
            .catch(error => { notify(error, 'error', 5000); }); 
    }

    function onRowInserting(e) {
        e.data.ordineId = props.myKey;
    };

    const onCellPreparedRate = (e) => {
        if (e.rowType === "data") {
            if (e.column.dataField === "statoId") 
            {   
                if (e.data.statoId === 1)
                    e.cellElement.style.cssText = "color: white; background-color: #558ea7";
                else if (e.data.statoId === 2)
                    e.cellElement.style.cssText = "color: white; background-color: orange";
                else if  (e.data.statoId === 3)
                    e.cellElement.style.cssText = "color: white; background-color: #1BE02B";
                else if (e.data.statoId === 4)
                    e.cellElement.style.cssText = "color: white; background-color: #30B7E0";
                else if  (e.data.statoId === 5)
                    e.cellElement.style.cssText = "color: white; background-color: green";
            }
        }
    }

    function onToolbarPreparing(e) {
        var item = e.toolbarOptions.items.find(item => item.name === "addRowButton"); 
        item.options.icon = "plus";  
        item.options.hint= "Nuova Rata Fatturazione";  
    };

    function refreshDataGrid() {
        orderInvocingDataGridRef.instance().refresh();
    }

    function onRowRataSelectionChanged({ selectedRowsData }) {
        const data = selectedRowsData[0];
        if (data != null) {
            setCurrentRataRow(data.id);
            if(data.fatturaId === null)
                setIsRowRataSelected(true);
            else
                setIsRowRataSelected(false);
            console.log("SELECTED RATA: " + data.id);
            //setCurrentId(e.currentSelectedRowKeys);
    
        } else {
            setIsRowRataSelected(false);
        }
    }

    function updateMovs() {    
        let result = confirm("<i>Aggiornare le scadenze dell'ordine selezionato'?</i>", "Aggiorna Scadenze");
          result.then((dialogResult) => {
          if  (dialogResult) {
            aggiornaMovimenti(props.myKey);
          }  
        });
    };
    
    const aggiornaMovimenti= (idOrdine) => {
          
        var path = "";
        path = '/api/OrdineCliente/UpdateProceedsMovements/';
        
        const url = process.env.REACT_APP_WEBAPP_DOMAIN + path + idOrdine;
      
        const requestOptions = {
          method: 'PUT',
          headers: {
              'Content-Type': 'application/json',
              Authorization: `Bearer ${user.token}`
          }
        };
      
        return fetch(url, requestOptions)
          .then(response => {
            if(response.ok) return response.json();
            //Global.CheckResponseAuth(response);
            return null;
          })
          .then(data => { 
            ;
            setTimeout(() => { 
              notify(data.message, data.success ? 'success' : 'error', 2000);         
            }, 100);
          })
          .catch(error => { notify(error, 'error', 5000); }); 
    }

    return (
        <div>
            <DataGrid id="grid-rate" 
                dataSource={remoteDataSource5}  
                onRowInserting={onRowInserting}
                onCellPrepared={onCellPreparedRate}
                onSelectionChanged={onRowRataSelectionChanged}
                onToolbarPreparing = {onToolbarPreparing}
                ref={ref => orderInvocingDataGridRef = ref}
            >
                <Toolbar>
                <Item location="after">
                    <ToolbarButton className="offer-toolbar"
                        icon='refresh'
                        hint='Aggiorna'
                        onClick={refreshDataGrid} 
                        />
                    </Item>
                    <Item location="after">
                        <ToolbarButton className="offer-toolbar"
                            icon='hidepanel'
                            hint='Aggiorna scadenze'
                            onClick={updateMovs} 
                           // disabled={!isRowRataSelected}
                        />
                    </Item>
                    <Item location="after">
                        <ToolbarButton className="offer-toolbar"
                            icon='money'
                            hint='Crea Fattura'
                            onClick={createInvoice} 
                            disabled={!isRowRataSelected}
                        />
                    </Item>
                    <Item name="addRowButton" />
                </Toolbar>
                <Selection mode="single" />
                <Column dataField="id" visible={false}/>
                <Column dataField="ordineId" visible={false}/>
                <Column dataField="numero" caption="Rata" width={80}>
                <Lookup dataSource={numeriRata} valueExpr="id" displayExpr="desc" />
                </Column>
                <Column dataField="percImporto" caption="% Importo" width={120} visible={true}> 
                <Format type="fixedPoint" precision={2} />
                </Column>
                <Column dataField="dataEmissione" dataType="date" format= {'dd/MM/yyyy'} width={120} caption="Data Emissione"/>
                <Column dataField="condizioniPagamentoId" caption="Pagamento" >
                <Lookup dataSource={condizioniPagam} valueExpr="id" displayExpr="descrizione" />
                </Column>
                <Column dataField="dataScadenza" dataType="date" format= {'dd/MM/yyyy'} width={120} caption="Data Scadenza"/>
                <Column dataField="statoId" caption="Stato Fattura" width={240} >
                <Lookup dataSource={statiRate} valueExpr="id" displayExpr="nome" />
                </Column>
                <Column dataField="note"width={260}/>
                <Column type="buttons">
                    <Button name="edit"  />
                    <Button name="delete"/>
                </Column>
                <Editing
                    mode="row"
                    allowUpdating={true}
                    allowAdding={true}
                    allowDeleting={true}
                    useIcons={true}
                >           
                </Editing>

                <MasterDetail
                    enabled={true}
                    component={orderDue}
                />
            </DataGrid>
        </div>
    )
};